import React, { useState } from 'react';
import './BetaBadge.css';

/**
 * Modern Beta Badge with Tooltip
 * Shows FlowVella is in active development
 */
export const BetaBadge: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="beta-badge-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={() => window.location.href = '/beta'}
    >
      <div className="beta-badge">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginRight: '4px' }}>
          <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="6" cy="6" r="1.5" fill="currentColor"/>
        </svg>
        BETA
      </div>

      {showTooltip && (
        <div className="beta-tooltip">
          <div className="beta-tooltip-header">
            <span className="beta-pulse"></span>
            We're actively developing!
          </div>
          <p className="beta-tooltip-text">
            FlowVella is back in active development. We're adding features, fixing bugs, and making it amazing.
          </p>
          <div className="beta-tooltip-link">
            Click to learn more →
          </div>
        </div>
      )}
    </div>
  );
};
